import { OnInit, Component, ViewChild, Output, EventEmitter, Input } from "@angular/core";
import { Subscription } from "rxjs";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { TranslateService } from "@ngx-translate/core";
import { Claims } from "src/app/_models/common/claims";
import { environment } from "src/environments/environment";
import { BaseComponent } from "src/app/shared/base/base-component";
import { ToastrService } from "ngx-toastr";
import { AlertService } from "src/app/alert-panel/alert.service";
import { DelegateService } from "src/app/_services/delegate/delegate.service";
import { ApiRequest, IApiresponse, MileageUOMEnum, JourneyTypeEnum, ExpenseErrorWarningTypeEnum } from "src/app/_models";
import { ActivationRequestStatus, ActivationRequestType } from "src/app/_models/enum/solo-enum";
import { ActivationRequestModel } from "src/app/_models/advance-mileage/org-office-codes";
import { UkMileageRateSettingService } from "src/app/_services/advance-mileage/uk-mileage-rate-setting.service";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { DynamicFormComponent } from "src/app/shared/forms/dynamic-form/dynamic-form.component";
import { DynamicFormService } from "src/app/shared/forms/dynamic-form/dynamic-form.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import {
    MultipleLegsAddJourneyFormModel, CalculateMileageResponse, SourceDestinationResponse,
    LocationDetail, MultipleLegsPopupModel, SelectDetourInputModel, SelectDetourOutputModel, MileageAllowance,
    IResourceMileageDetailsResponse, MileageData, CalculateMileageRequest
} from "src/app/_models/claimant-on-web/claimant-on-web";
import { AlertPanelModel } from 'src/app/_models/common/alertPanelModel';
import { ClaimantOnWebService } from "src/app/_services/claimant-on-web/claimant-on-web.service";
import { GetField } from "src/app/shared/forms/form-functions/form-functions";
import { BaseCategoryTypeEnum } from "../../../../_models";

@Component({
    selector: "add-journey-panel",
    templateUrl: "./add-journey-panel.component.html",
    standalone: false
})
export class AddjourneyPanelComponent extends BaseComponent implements OnInit {
    @ViewChild(DynamicFormComponent) journeyForm: DynamicFormComponent;

    @Input() inputModel: MultipleLegsPopupModel;
    @Input() mileageAllowance: MileageAllowance[];
    @Input() resourceMileageDetails: IResourceMileageDetailsResponse;
    @Input() vehicleResponse: any;
    @Input() expenseModel: any;
    @Input() isCarbonFootprintReporting:boolean;
    @Output() closePanelEvent = new EventEmitter<boolean>();
    @Output() submitEvent = new EventEmitter<any>();
    @Output() deleteEvent = new EventEmitter<any>();

    claimsSubscription: Subscription;
    userActionEventSubscription: Subscription;
    claims: Claims;
    panelHeading: string;

    disableSaveButton: boolean = false;

    journeyFormModel: MultipleLegsAddJourneyFormModel;
    journeyFormFields: FormlyFieldConfig[] = [];
    // Hides Distance / Carbon Emission / Detour / Justification Notes / Passenger-Load
    // until the user clicks Calculate. Set true when editing or after Calculate succeeds.
    isMileageCalculated: boolean = false;

    showWarningAlerts: boolean = false;
    showWarningAlertsModel: AlertPanelModel;

    showSelectDetourPanel: boolean = false;
    selectDetourInputModel: SelectDetourInputModel;

    showDebtourNotActivatedAlertPanel: boolean;
    debtourNotActivatedAlertModel: AlertPanelModel;

    showAddPassengerLoadPanel: boolean = false;
    passengerLoadInputModel: MileageAllowance[];

    showPassengerLoadNotActivatedAlertPanel: boolean;
    passengerLoadNotActivatedAlertModel: AlertPanelModel;
    mileageUOMText: string;
    carbonEmissionText:string;

    showDeleteConfirmationAlert: boolean = false;
    deleteConfirmationAlertModel: AlertPanelModel;

    showUnsavedChangesAlert: boolean = false;
    unsavedChangesAlertModel: AlertPanelModel;

    showChargingTypeActivationAlert = false;
    chargingTypeActivationAlertModel = new AlertPanelModel(false, "", [""], "", "", true, "");
    requestedChargingType: number = 0;

    constructor(
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private toastr: ToastrService,
        private alertService: AlertService,
        private delegateService: DelegateService,
        private ngxService: NgxUiLoaderService,
        private dynamicFormService: DynamicFormService,
        private claimantOnWebService: ClaimantOnWebService,
        private ukMileageRateSettingService: UkMileageRateSettingService,
    ) {
        super();
        this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });
    }

    ngOnInit(): void {
        this.fnSetPanelHeading();
        if (this.inputModel) {
            this.carbonEmissionText = this.translate.instant('text_carbonemission');
            this.mileageUOMText = this.inputModel.mileageUOM == MileageUOMEnum.Kilometre
                ? this.translate.instant("text_km")
                : this.translate.instant("text_m");

            if (!this.inputModel.isEditMode) {
                if (this.inputModel.isReturnJourney) {
                    this.fnOnReturnJourney(this.inputModel.selectedSequence);
                }
                else {
                    this.fnInitializeForm();
                }
            }
            else {
                if (this.inputModel.isEditMode) {
                    this.fnEditInputLeg(this.inputModel.selectedSequence);
                }
            }
        }
    }

    fnOnReturnJourney(selectedSequence) {

        if (this.inputModel.multipleLegList && this.inputModel.multipleLegList.length > 0) {
            let data = this.inputModel.multipleLegList.find(d => d.sequence == selectedSequence);

            if (data) {
                this.journeyFormModel = new MultipleLegsAddJourneyFormModel();
                this.journeyFormModel.fromLocation = data.toLocation;
                this.journeyFormModel.toLocation = data.fromLocation;
                this.journeyFormModel.sequence = data.sequence + 1;
                this.journeyFormModel.notes = data.notes;
                this.journeyFormModel.detour = data.detour ? data.detour : null;
                this.journeyFormModel.detourJustificationNotes = data.detourJustificationNotes;
                this.journeyFormModel.tagList = [];
                this.journeyFormModel.isEditMode = false;
                this.journeyFormModel.distance = null;
                this.journeyFormModel.isFromLocationDisabled = true;
                this.journeyFormModel.mileageAllowance = data.mileageAllowance;
                this.journeyFormModel.allowanceDescription = data.mileageAllowance ? data.mileageAllowance.allowanceDescription : "";
                this.journeyFormModel.fromLocationDescription = this.journeyFormModel.fromLocation.location;
                this.journeyFormModel.toLocationDescription = this.journeyFormModel.toLocation.location;
                this.journeyFormModel.userHomeAddressInfo = this.resourceMileageDetails?.userHomeAddressInfo;
                this.journeyFormModel.userOfficeAddressInfo = this.resourceMileageDetails?.userOfficeAddressInfo;
                this.journeyFormModel.triangulationRule = this.resourceMileageDetails?.triangulationRule;
                this.journeyFormModel.googleCallsInfo = this.resourceMileageDetails?.googleCallsInfo;
                this.journeyFormModel.totalTriangulatedDistanceText = data.totalTriangulatedDistanceText;
                this.journeyFormModel.carbonFootprint = data.carbonFootprint;
                this.journeyFormModel.isOtherOfficeAvailable = this.resourceMileageDetails?.isOtherOfficeAvailable;
                this.journeyFormModel.currentLocation = this.expenseModel.mileage.currentLocation;
                if (this.expenseModel?.isElectricCar) {
            this.journeyFormModel.chargingType = data.chargingType ?? 0;
        }
                setTimeout(() => {
                    this.fnInitializeForm();
                }, 80);
            }
        }
    }

    fnEditInputLeg(sequence) {
        if (this.inputModel.multipleLegList && this.inputModel.multipleLegList.length > 0) {
            let editLegDetails = this.inputModel.multipleLegList.find(d => d.sequence == sequence);
            if (editLegDetails) {
                this.fnSelectLegDetailsForEdit(editLegDetails);
            }
        }
    }


    fnSelectLegDetailsForEdit(data) {
        this.journeyFormModel = new MultipleLegsAddJourneyFormModel();
        this.journeyFormModel.fromLocation = data.fromLocation;
        this.journeyFormModel.toLocation = data.toLocation;
        this.journeyFormModel.distance = data.distance;
        this.journeyFormModel.sequence = data.sequence;
        this.journeyFormModel.carbonFootprint = data.carbonFootprint;
        this.journeyFormModel.notes = data.notes;
        this.journeyFormModel.detour = data.detour ? data.detour : null;
        this.journeyFormModel.detourJustificationNotes = data.detourJustificationNotes;
        this.journeyFormModel.tagList = [];
        this.journeyFormModel.isEditMode = true;
        this.journeyFormModel.isFromLocationDisabled = data.sequence > 1 ? true : false;
        this.journeyFormModel.mileageAllowance = data.mileageAllowance;
        this.journeyFormModel.allowanceDescription = data.mileageAllowance ? data.mileageAllowance.allowanceDescription : "";
        this.journeyFormModel.fromLocationDescription = this.journeyFormModel.fromLocation.location;
        this.journeyFormModel.toLocationDescription = this.journeyFormModel.toLocation.location;
        this.journeyFormModel.userHomeAddressInfo = this.resourceMileageDetails?.userHomeAddressInfo;
        this.journeyFormModel.userOfficeAddressInfo = this.resourceMileageDetails?.userOfficeAddressInfo;
        this.journeyFormModel.triangulationRule = this.resourceMileageDetails?.triangulationRule;
        this.journeyFormModel.googleCallsInfo = this.resourceMileageDetails?.googleCallsInfo;
        this.journeyFormModel.totalTriangulatedDistanceText = data.totalTriangulatedDistanceText;
        this.journeyFormModel.isOtherOfficeAvailable = this.resourceMileageDetails?.isOtherOfficeAvailable;
        this.journeyFormModel.currentLocation = this.expenseModel.mileage.currentLocation;
        if (this.expenseModel?.isElectricCar) {
            this.journeyFormModel.chargingType = data.chargingType ?? 0;
        }
        this.isMileageCalculated = true;
        this.fnInitializeForm();
    }


    fnSetPanelHeading() {
        if (this.inputModel) {
            this.panelHeading = this.inputModel.isEditMode
                ? this.translate.instant('edit_journey')
                : this.translate.instant('add_journey');
        }
    }

    ngOnDestroy() {
        this.claimsSubscription.unsubscribe();
        if (this.userActionEventSubscription) {
            this.userActionEventSubscription.unsubscribe();
        }
    }

    canDeactivate(): boolean {
        return !this.journeyForm.form.dirty;
    }

    fnClosePanel() {
        if (this.canDeactivate()) {
            this.closePanelEvent.emit(true);
        }
        else {
            this.fnShowUnsavedChangesAlert();
        }
    }

    fnShowUnsavedChangesAlert() {
        this.unsavedChangesAlertModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [
                this.translate.instant("switch_multiple_leg_confirmation_note2"),
            ],
            this.translate.instant("label_cancel"),
            this.translate.instant("label_confirm"),
            true,
            this.translate.instant("switch_multiple_leg_confirmation_note2")
        );
        this.showUnsavedChangesAlert = true;
    }

    fnUnsavedChangesAlertReceiver(returnValue) {
        this.showUnsavedChangesAlert = false;
        if (returnValue) {
            this.fnMarkFormAsPristine();
            this.closePanelEvent.emit(true);
        }
    }

    fnInitializeForm() {

        if (!this.inputModel.isEditMode && !this.inputModel.isReturnJourney) {
            this.fnInitialiseFormModel();
        }

        let fields: FormlyFieldConfig[] = [];

        fields.push({
            fieldGroupClassName: 'block row',
            fieldGroup: [
                 ...(this.expenseModel?.isElectricCar && !this.resourceMileageDetails?.customMileageRate?.isCustomRate ? [{
                    key: 'chargingType',
                    type: 'formly-electric-charging-type',
                    className: 'col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-left-3 mb-3',
                    props: {
                        mileageRateInfo: this.expenseModel?.vehicleMileageRateInfo ?? [],
                        chargingType: this.expenseModel?.vehicleChargingType ?? 0,
                        activationRequestStatus: this.expenseModel?.vehicleActivationRequestStatus ?? 0,
                        onDisabledClick: (ct: number) => {
                            this.fnShowChargingTypeActivationAlert(ct);
                        },
                        change: (field, $event) => {
                            this.fnMarkFormAsDirty();
                        },
                    },
                }] : []),
                {
                    key: 'fromLocationDescription',
                    type: 'google-location-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-3',
                    templateOptions: {
                        label: this.translate.instant('text_from'),
                        placeholder: '',
                        required: true,
                        modelKey: 'fromLocation',
                        hideSameLocationMessage: true,
                        change: (field, $event) => {
                            this.fnOnMileageAddressChange();
                        }
                    },
                    expressionProperties: { 'templateOptions.disabled': 'model.isFromLocationDisabled' }
                },
                {
                    key: 'toLocationDescription',
                    type: 'google-location-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-3',
                    templateOptions: {
                        label: this.translate.instant('text_to'),
                        placeholder: '',
                        required: true,
                        modelKey: 'toLocation',
                        change: (field, $event) => {
                            this.fnOnMileageAddressChange();
                        }
                    }
                },
                {
                    key: 'distance',
                    type: 'text-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-3',
                    templateOptions: {
                        label: `${this.translate.instant('text_distance')} (${this.mileageUOMText})`,
                        placeholder: '',
                        required: true,
                        disabled: true,
                        htmlCustomMsg: this.journeyFormModel.totalTriangulatedDistanceText

                    },
                },
                {
                    key: 'carbonFootprint',
                    type: 'text-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-3',
                    hideExpression: !this.isCarbonFootprintReporting,
                    templateOptions: {
                        label: `${this.translate.instant('carbon_emission')} (${this.carbonEmissionText})`,
                        placeholder: '',
                        required: true,
                        disabled: true
                    }
                },
                {
                    key: 'calculateMileage',
                    type: 'formly-button',
                    templateOptions: {
                        label: this.translate.instant('text_calculate'),
                        placeholder: '',
                        required: false,
                        buttonClass: 'btn btn-outline-primary bg-white margin-top-15',
                        iconClass: 'far fa-route',
                        click: (field, $event) => {
                            this.fnCalculateMileageMultipleLeg()
                        }
                    },
                    expressionProperties: {
                        'templateOptions.disabled': 'model.disabledCalculateBtn'
                    }
                },
                {
                    key: 'detour',
                    type: 'text-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-3',
                    hideExpression: () => !(this.expenseModel.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle)
                                          || !this.inputModel?.isDetourEnabled
                                          || !this.isMileageCalculated,
                    templateOptions: {
                        label: `${this.translate.instant('enter_detour')} (${this.mileageUOMText})`,
                        placeholder: '',
                        required: false,
                        readonly: true,
                        click: (field, $event) => {
                            this.fnShowSelectDetourPanel();
                        }
                    }
                },
                {
                    key: 'allowanceDescription',
                    type: 'text-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-3',
                    hideExpression: () => !(this.expenseModel.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle)
                                          || !this.inputModel?.isPassengerLoadPurchased
                                          || !this.inputModel?.isPassengerLoadOn
                                          || !this.isMileageCalculated,
                    templateOptions: {
                        label: this.translate.instant('text_passenger_load'),
                        placeholder: '',
                        required: false,
                        readonly: true,
                        click: (field, $event) => {
                            this.fnShowAddPassengerLoadPanel();
                        }
                    }
                },
                {
                    key: 'notes',
                    type: 'text-input',
                    className: 'col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-left-3',
                    hideExpression: !(this.expenseModel.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle),
                    templateOptions: {
                        label: this.translate.instant('label_notes'),
                        placeholder: '',
                        required: false,
                        maxLength: 200,
                        maxLengthCount: true,
                    }
                },
            ] 
            });

        this.journeyFormFields = fields;
    }

    fnInitialiseFormModel() {
        this.journeyFormModel = new MultipleLegsAddJourneyFormModel();

        let location: LocationDetail = { location: '', latitude: 0, longitude: 0, locationTrackTime: 0, placeId: 0 };
        this.journeyFormModel.fromLocation = location;
        this.journeyFormModel.toLocation = location;
        this.journeyFormModel.sequence = this.inputModel.multipleLegList.length > 0 ? this.inputModel.multipleLegList.length + 1 : 1;
        this.journeyFormModel.notes = "";
        this.journeyFormModel.detour = null;
        this.journeyFormModel.detourJustificationNotes = "";
        this.journeyFormModel.tagList = [];
        this.journeyFormModel.mileageAllowance = null;
        this.journeyFormModel.allowanceDescription = "";
        this.journeyFormModel.userHomeAddressInfo = this.resourceMileageDetails?.userHomeAddressInfo;
        this.journeyFormModel.userOfficeAddressInfo = this.resourceMileageDetails?.userOfficeAddressInfo;
        this.journeyFormModel.triangulationRule = this.resourceMileageDetails?.triangulationRule;
        this.journeyFormModel.googleCallsInfo = this.resourceMileageDetails?.googleCallsInfo;
        this.journeyFormModel.disabledCalculateBtn = true;
        this.journeyFormModel.carbonFootprint = null;
        //set from location
        this.journeyFormModel.fromLocation = this.fnGetFromLocation();
        this.journeyFormModel.fromLocationDescription = this.journeyFormModel.fromLocation.location;
        this.journeyFormModel.toLocationDescription = this.journeyFormModel.toLocation.location;
        this.journeyFormModel.isFromLocationDisabled = this.inputModel.multipleLegList.length > 0 ? true : false;
        this.journeyFormModel.isOtherOfficeAvailable = this.resourceMileageDetails?.isOtherOfficeAvailable;
        this.journeyFormModel.currentLocation = this.expenseModel.mileage.currentLocation;
        if (this.expenseModel?.isElectricCar) {
            const ct = this.expenseModel?.vehicleChargingType ?? 3;
            this.journeyFormModel.chargingType = (ct === 2) ? 2 : 1;
        }
    }

    fnGetFromLocation() {
        let location: LocationDetail = { location: '', latitude: 0, longitude: 0, locationTrackTime: 0, placeId: 0 };
        if (this.inputModel.multipleLegList && this.inputModel.multipleLegList.length > 0) {
            let lastLegDetails = this.inputModel.multipleLegList[this.inputModel.multipleLegList.length - 1];
            if (lastLegDetails) {
                location = lastLegDetails.toLocation;
            }
        }
        return location;
    }


fnIsBtnCalculateMileageDisbled() {
  let isDisabled = false;
  if (!this.journeyFormModel.fromLocation.location
    || !this.journeyFormModel.fromLocation.location.trim()
    || !this.journeyFormModel.toLocation.location
    || !this.journeyFormModel.toLocation.location.trim()
    || !this.journeyFormModel.fromLocation.placeId
    || !this.journeyFormModel.toLocation.placeId) {
    isDisabled = true;
  }
  
  if (!isDisabled) {
    const fromPlaceId = this.journeyFormModel.fromLocation?.placeId;
    const toPlaceId = this.journeyFormModel.toLocation?.placeId;
    const fromText = (this.journeyFormModel.fromLocation?.location || '').trim().toLowerCase();
    const toText = (this.journeyFormModel.toLocation?.location || '').trim().toLowerCase();
    

      if (fromPlaceId || toPlaceId) {
          if (fromPlaceId && toPlaceId && fromPlaceId === toPlaceId) {
              isDisabled = true;
          }
      } else if (fromText.length >= 6 && toText.length >= 6 && fromText === toText) {
                isDisabled = true;
    }
  }

  this.journeyFormModel.disabledCalculateBtn = isDisabled;
}

    fnSaveJourneyDetails() {
        this.dynamicFormService.onFormSubmitted(true);
        this.disableSaveButton = true;

        if (this.journeyForm.form.invalid) {
            this.disableSaveButton = false;
            return;
        }
        // zero distance validation
        if (!Number(this.journeyFormModel.distance)
            && !(this.calculateMileageDetails && this.calculateMileageDetails.mileageDetailList
                && this.calculateMileageDetails.mileageDetailList.length > 0
                && this.calculateMileageDetails.mileageDetailList[0].amount)) {
            this.journeyFormModel.distance = null;
            this.disableSaveButton = false;
            this.fnShowWarningAlerts(ExpenseErrorWarningTypeEnum.ZeroDistance);
            return;
        }

        let legModel = new SourceDestinationResponse();
        let location: LocationDetail = { location: '', latitude: 0, longitude: 0, locationTrackTime: 0, placeId: 0 };
        legModel.fromLocation = location;
        legModel.toLocation = location;
        legModel.fromLocation = this.journeyFormModel.fromLocation;
        legModel.toLocation = this.journeyFormModel.toLocation;
        legModel.notes = this.journeyFormModel.notes;
        legModel.sequence = this.journeyFormModel.sequence;
        legModel.detour = this.journeyFormModel.detour ? Number(this.journeyFormModel.detour) : 0;
        legModel.detourJustificationNotes = this.journeyFormModel.detourJustificationNotes;
        legModel.mileageAllowance = this.journeyFormModel.mileageAllowance;
        legModel.distance = this.journeyFormModel.distance;
        legModel.tagList = [];
        legModel.carbonFootprint = this.journeyFormModel.carbonFootprint;
        legModel.chargingType = this.journeyForm?.form?.get('chargingType')?.value ?? this.journeyFormModel.chargingType ?? 0;
        this.submitEvent.emit(legModel);
    }

    fnOnMileageAddressChange() {
        this.journeyFormModel.distance = null;
        // distance control is removed by Formly while hideExpression is true (pre-calculate).
        this.journeyForm.form.controls.distance?.setValue(null);
        let htmlCustomMsg = GetField('distance', this.journeyFormFields);
        if (htmlCustomMsg) {
            htmlCustomMsg.templateOptions.htmlCustomMsg = '';
        }

        const from = (this.journeyFormModel.fromLocation?.location || '').trim().toLowerCase();
        const to = (this.journeyFormModel.toLocation?.location || '').trim().toLowerCase();
        const textMatch = from.length >= 6 && to.length >= 6 && from === to;
        
        const fromPlaceId = this.journeyFormModel.fromLocation?.placeId;
        const toPlaceId = this.journeyFormModel.toLocation?.placeId;
        const placeIdMatch = !!(fromPlaceId && toPlaceId && fromPlaceId === toPlaceId);

        let isSameLocation = textMatch || placeIdMatch;

        let toField = GetField('toLocationDescription', this.journeyFormFields);
        if (toField && toField.templateOptions) {
            toField.templateOptions['isSameLocationDetected'] = isSameLocation;
        }
        
        let fromField = GetField('fromLocationDescription', this.journeyFormFields);
        if (fromField && fromField.templateOptions) {
            fromField.templateOptions['isSameLocationDetected'] = isSameLocation;
        }

        this.isMileageCalculated = false;
        this.fnIsBtnCalculateMileageDisbled();
    }
    calculateMileageDetails: CalculateMileageResponse;
    fnCalculateMileageMultipleLeg() {

        this.fnMarkFormAsDirty();

        //check validation
        if (!this.journeyFormModel.fromLocation.location || !this.journeyFormModel.toLocation.location ||
            !this.journeyFormModel.fromLocation.placeId || !this.journeyFormModel.toLocation.placeId) {
            return;
        }

        // Start Loader

        this.ngxService.start();
        this.disableSaveButton = true;

        let vehicleId = 0;

        let defaultVehicle = this.vehicleResponse.find(it => it.isDefault);
        if (defaultVehicle) {
            vehicleId = defaultVehicle.vehicleId
        }

        let request = new ApiRequest<CalculateMileageRequest>("CalculateMileageMultipleLeg", environment.applicationVersion, environment.requestId);
        let requestInfo = new CalculateMileageRequest();
        requestInfo.baseCategoryId = this.expenseModel.baseCategoryId;
        requestInfo.orgExpenseCategoryId = this.expenseModel.orgExpenseCategoryId;
        requestInfo.journeyType = JourneyTypeEnum.Multiple;
        let vehicleDetail = this.vehicleResponse.find(it => it.vehicleId == this.expenseModel.mileage.vehicleId);
        requestInfo.orgVehicleTypeMapId = (this.inputModel.isMultipleVehiclePurchase
            ? (vehicleDetail ? vehicleDetail.orgVehicleTypeMapId : 0) : this.resourceMileageDetails ? this.resourceMileageDetails.vehicleDetailResponse.orgVehicleTypeMapId : 0);

        requestInfo.vehicleTypeId = (this.inputModel.isMultipleVehiclePurchase
            ? (vehicleDetail ? vehicleDetail.vehicleTypeId : 0) : this.resourceMileageDetails ?  this.resourceMileageDetails.vehicleDetailResponse.vehicleTypeId : 0);

        requestInfo.vehicleId = (this.inputModel.isMultipleVehiclePurchase ? this.expenseModel.mileage.vehicleId : vehicleId);
        requestInfo.mileageDateDetails = this.fnCalculateMileageMultipleLegRequest(null);
        requestInfo.userId = this.inputModel.claimantId;
        requestInfo.orgID = this.claims.OrgId;
        request.requestInfo = requestInfo;
        this.claimantOnWebService.CalculateMileageMultipleLeg(request).subscribe((response: IApiresponse<CalculateMileageResponse>) => {

            //Stop Loader
            this.ngxService.stop();
            this.disableSaveButton = false;

            if (response.responseInfo != null) {
                if (response.responseInfo.expiredLocationType > 0) {
                    this.fnShowExpiredLocationPanel(response.responseInfo.expiredLocationType);
                }
                else if (response.errorInfo && response.errorInfo.length > 0) {
                    this.expenseModel.disabledCalculateBtn = false;
                    this.ShowGoogleServiceErrorPanel();
                }
                else {
                    this.calculateMileageDetails = response.responseInfo;

                    let sourceDestinationInformation = this.calculateMileageDetails.mileageDetailList[0].sourceDestinationInformation;
                    if (sourceDestinationInformation && sourceDestinationInformation.length > 0) {
                        let calculatedDetails = sourceDestinationInformation[0];
                        if (calculatedDetails) {
                            if (calculatedDetails.chargingType) {
                                this.journeyFormModel.chargingType = calculatedDetails.chargingType;
                            }
                            // Distance and carbonFootprint controls always exist (no hideExpression
                            // on these fields). Push into both the form control and the model so
                            // the disabled inputs display the value AND the model stays in sync.
                            const distanceStr = calculatedDetails.distance.toFixed(2);
                            this.journeyForm.form?.controls?.distance?.setValue(distanceStr);
                            this.journeyFormModel.distance = distanceStr as any;
                            if (this.isCarbonFootprintReporting) {
                                const carbonStr = calculatedDetails.carbonFootprint.toFixed(2);
                                this.journeyForm.form?.controls?.carbonFootprint?.setValue(carbonStr);
                                this.journeyFormModel.carbonFootprint = carbonStr as any;
                            }
                            this.isMileageCalculated = true;

                            let htmlCustomMsg = GetField('distance', this.journeyFormFields);
                            if (htmlCustomMsg) {
                                if (this.calculateMileageDetails.mileageDetailList[0].totalTriangulatedDistance) {
                                    let totalTriangulatedDistanceText = this.translate.instant("passenger_load_step_10_msg")
                                        + '<span class="padding-left-0 f-12 color-red fw-700">' + this.translate.instant("passenger_load_step_11_msg")
                                        + calculatedDetails.triangulatedDistance.toFixed(2).toString()
                                        + ' ' + (this.expenseModel.mileage.mileageUOM == MileageUOMEnum.Kilometre ? 'km' : 'm')
                                        + '</span>'
                                        + this.translate.instant("passenger_load_step_12_msg");
                                    htmlCustomMsg.props.htmlCustomMsg = totalTriangulatedDistanceText;
                                } else {
                                    htmlCustomMsg.props.htmlCustomMsg = '';
                                }
                            }
                        }
                    }
                }

            }

        });
    }

    fnCalculateMileageMultipleLegRequest(detourJustificationNotes) {
        let vehicleId = 0;

        let defaultVehicle = this.vehicleResponse.find(it => it.isDefault);
        if (defaultVehicle) {
            vehicleId = defaultVehicle.vehicleId
        }

        let mileage = new MileageData();
        mileage.journeyType = JourneyTypeEnum.Single;
        mileage.mileageDate = new Date(this.expenseModel.expenseDate).valueOf();
        mileage.operationalInformation = null;
        mileage.vehicleId = (this.inputModel.isMultipleVehiclePurchase ? this.expenseModel.mileage.vehicleId : vehicleId);
        mileage.customMileageRate = this.resourceMileageDetails ? this.resourceMileageDetails.customMileageRate : null;

        let sourceDestinationarray = [];
        let legModel = new SourceDestinationResponse();
        let location: LocationDetail = { location: '', latitude: 0, longitude: 0, locationTrackTime: 0, placeId: 0 };
        legModel.fromLocation = location;
        legModel.toLocation = location;
        legModel.fromLocation = this.journeyFormModel.fromLocation;
        legModel.toLocation = this.journeyFormModel.toLocation;
        legModel.notes = this.journeyFormModel.notes;
        legModel.sequence = this.journeyFormModel.sequence;
        legModel.detour = this.journeyFormModel.detour ? Number(this.journeyFormModel.detour) : 0;
        legModel.detourJustificationNotes = this.journeyFormModel.detourJustificationNotes;
        legModel.mileageAllowance = this.journeyFormModel.mileageAllowance;
        legModel.chargingType = this.journeyForm?.form?.get('chargingType')?.value ?? this.journeyFormModel.chargingType ?? 0;
        sourceDestinationarray.push(legModel)

        mileage.sourceDestinationInformation = sourceDestinationarray;
        let mileageData = [];
        mileageData.push(mileage);
        return mileageData;
    }


    fnShowWarningAlerts(expenseErrorWarningType: number) {

        switch (expenseErrorWarningType) {

            case ExpenseErrorWarningTypeEnum.ZeroDistance:
                this.showWarningAlertsModel = new AlertPanelModel(
                    true,
                    this.translate.instant("label_alert"),
                    [],
                    "",
                    this.translate.instant("text_ok"),
                    true,
                    this.translate.instant("journey_with_zero_amount_cannot_be_saved")
                );
                this.showWarningAlerts = true;
                break;

            default:
                break;
        }
    }

    fnShowWarningAlertsReceiver(returnValue) {
        this.showWarningAlertsModel = null;
        this.showWarningAlerts = false;
    }


    //Mileage Detour
    fnShowSelectDetourPanel() {

        if (this.inputModel.isAdvanceMileagePurchasedOrTrial && this.inputModel.isDetourEnabled) {
            this.selectDetourInputModel = new SelectDetourInputModel();
            this.selectDetourInputModel.detour = this.journeyFormModel.detour;
            this.selectDetourInputModel.detourJustificationNotes = this.journeyFormModel.detourJustificationNotes;

            this.showSelectDetourPanel = true;

        } else {
            this.fnShowDebtourNotActivatedAlertPanel();
        }
    }

    fnCloseSelectDetourPanel(isClose: boolean) {
        if (isClose) {
            this.showSelectDetourPanel = false;
        }
    }

    fnSelectDetourPanel(selectedData: SelectDetourOutputModel) {
        if (selectedData) {

            if (this.journeyForm && this.journeyForm.form) {
                this.journeyForm.form.controls.detour?.setValue(Number(selectedData.detour).toFixed(2));
            }
            // detourJustificationNotes no longer has a form control (field removed
            // to match formly-mileage). Persist on the model so it still flows
            // through fnSaveJourneyDetails into the saved leg payload.
            this.journeyFormModel.detourJustificationNotes = selectedData.detourJustificationNotes;

            this.showSelectDetourPanel = false;
            this.fnCalculateMileageMultipleLeg();
        }
    }

    fnShowDebtourNotActivatedAlertPanel() {
        this.debtourNotActivatedAlertModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [],
            "",
            this.translate.instant("text_ok"),
            true,
            this.translate.instant("create_expense_detour_not_subscribed_alert")
        );

        this.showDebtourNotActivatedAlertPanel = true;
    }

    fnCloseDebtourNotActivatedAlertPanel(event) {
        this.showDebtourNotActivatedAlertPanel = false;
    }

    //Passenger Load
    fnShowAddPassengerLoadPanel() {
        if (!this.inputModel.isPassengerLoadPurchased || !this.inputModel.isPassengerLoadOn) {
            // field is hidden via hideExpression when not purchased or P&L is OFF � defensive no-op
            return;
        }
        if (this.mileageAllowance && this.mileageAllowance.length > 0) {
            this.passengerLoadInputModel = this.mileageAllowance ? this.mileageAllowance : [];
            if (this.journeyFormModel && this.journeyFormModel.mileageAllowance) {
                this.passengerLoadInputModel.forEach(element => {
                    if (element.allowanceId == this.journeyFormModel.mileageAllowance.allowanceId) {
                        element.selected = true;
                    }
                    else {
                        element.selected = false;
                    }
                });
            }
            this.showAddPassengerLoadPanel = true;
        } else {
            this.fnShowPassengerLoadVehicleNotMappedAlertPanel();
        }
    }

    fnMarkMileageAllowanceUnselect() {
        if (this.mileageAllowance) {
            this.mileageAllowance.forEach(element => {
                element.selected = false;
            });
        }
    }

    fnCloseAddPassengerLoadPanel(isClose: boolean) {
        if (isClose) {
            this.showAddPassengerLoadPanel = false;
            this.passengerLoadInputModel = null;
            this.fnMarkMileageAllowanceUnselect();
        }
    }

    fnSelectPassengerLoad(selectedData: MileageAllowance) {
        if (selectedData) {
            if (this.journeyForm && this.journeyForm.form) {
                this.journeyFormModel.mileageAllowance = selectedData;
                this.journeyForm.form.controls.allowanceDescription.setValue(selectedData.allowanceDescription);
            }
        }
        this.showAddPassengerLoadPanel = false;
        this.fnCalculateMileageMultipleLeg();
    }

    fnClearDetour() {
        this.journeyFormModel.detour = null;
        this.journeyFormModel.detourJustificationNotes = "";
        if (this.journeyForm && this.journeyForm.form) {
            this.journeyForm.form.controls.detour.setValue(null);
            this.journeyForm.form.controls.detourJustificationNotes.setValue("");
        }
        this.journeyForm.form.markAsDirty();
        this.fnCalculateMileageMultipleLeg();
    }

    fnClearPassengerLoad() {
        this.journeyFormModel.mileageAllowance = null;
        this.journeyFormModel.allowanceDescription = "";
        if (this.journeyForm && this.journeyForm.form) {
            this.journeyForm.form.controls.allowanceDescription.setValue("");
        }
        this.fnMarkMileageAllowanceUnselect();
        this.journeyForm.form.markAsDirty();
        this.fnCalculateMileageMultipleLeg();
    }

    fnShowPassengerLoadNotActivatedAlertPanel() {
        this.passengerLoadNotActivatedAlertModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [],
            "",
            this.translate.instant("text_ok"),
            true,
            this.translate.instant("create_expense_passenger_load_not_subscribed_alert")
        );

        this.showPassengerLoadNotActivatedAlertPanel = true;
    }

    fnClosePassengerLoadNotActivatedAlertPanel(event) {
        this.showPassengerLoadNotActivatedAlertPanel = false;
    }

    fnShowDeleteConfirmationAlert() {
        this.deleteConfirmationAlertModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [
                this.translate.instant("leg_delete_confirmation_note"),
            ],
            this.translate.instant("label_cancel"),
            this.translate.instant("label_confirm"),
            true,
            this.translate.instant("leg_delete_confirmation_note")
        );
        this.showDeleteConfirmationAlert = true;
    }

    fnDeleteConfirmationAlertReceiver(returnValue) {
        if (returnValue) {
            this.deleteEvent.emit(this.journeyFormModel.sequence);
        }
        this.deleteConfirmationAlertModel = null;
        this.showDeleteConfirmationAlert = false;
    }


    fnMarkFormAsPristine() {
        if (this.journeyForm && this.journeyForm.form) {
            this.journeyForm.form.markAsPristine();
        }
    }

    fnMarkFormAsDirty() {
        if (this.journeyForm && this.journeyForm.form) {
            this.journeyForm.form.markAsDirty();
        }
    }
    showGoogleServiceErrorPopup: boolean = false;
    GoogleServiceErrorPopupModel = new AlertPanelModel(false, "", [""], "", "", true, "");
    ShowGoogleServiceErrorPanel() {

        this.GoogleServiceErrorPopupModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [],
            '',
            this.translate.instant("text_ok"),
            true
            , this.translate.instant("google_service_down_msg")
        );
        this.showGoogleServiceErrorPopup = true;
    }
    fnShowExpiredLocationPanel(expiredLocationType: number) {
        const msgMap = { 1: 'expired_office_location_msg', 2: 'expired_home_location_msg', 3: 'expired_location_msg' };
        this.GoogleServiceErrorPopupModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [],
            '',
            this.translate.instant("text_ok"),
            true
            , this.translate.instant(msgMap[expiredLocationType] || "google_service_down_msg")
        );
        this.showGoogleServiceErrorPopup = true;
    }
    fnGoogleServiceErrorPopupReceiver() {
        this.showGoogleServiceErrorPopup = false;
        this.journeyFormModel.disabledCalculateBtn = false;
        this.GoogleServiceErrorPopupModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
    }

    fnShowChargingTypeActivationAlert(ct: number = 0) {
        this.requestedChargingType = ct;
        if (this.expenseModel.vehicleActivationRequestStatus === ActivationRequestStatus.RequestSent) {
            this.chargingTypeActivationAlertModel = new AlertPanelModel(
                true,
                this.translate.instant("label_alert"),
                [],
                "",
                this.translate.instant("text_ok"),
                true,
                this.translate.instant("charging_type_request_sent_msg")
            );
        } else {
            this.chargingTypeActivationAlertModel = new AlertPanelModel(
                true,
                this.translate.instant("label_alert"),
                [],
                this.translate.instant("label_close"),
                this.translate.instant("send_request"),
                true,
                this.translate.instant("charging_type_disabled_msg")
            );
        }
        this.showChargingTypeActivationAlert = true;
    }

    fnChargingTypeActivationAlertReceiver(returnValue) {
        this.showChargingTypeActivationAlert = false;
        if (returnValue && this.expenseModel.vehicleActivationRequestStatus !== ActivationRequestStatus.RequestSent) {
            let request = new ApiRequest<ActivationRequestModel>(
                "ActivationRequest",
                1.0,
                ""
            );
            let req = new ActivationRequestModel();
            req.id = this.resourceMileageDetails?.vehicleDetailResponse?.orgVehicleTypeMapId ?? 0;
            req.type = ActivationRequestType.ElectricChargingType;
            req.subType = this.requestedChargingType;
            request.requestInfo = req;
            this.ukMileageRateSettingService
                .SoloSaveActivationRequest(request)
                .subscribe((res: IApiresponse<string>) => {
                    this.toastr.success(this.translate.instant("success"));
                    this.expenseModel.vehicleActivationRequestStatus = ActivationRequestStatus.RequestSent;
                    if (this.vehicleResponse) {
                        let vehicle = this.vehicleResponse.find(x => x.orgVehicleTypeMapId == req.id);
                        if (vehicle) {
                            vehicle.activationRequestStatus = ActivationRequestStatus.RequestSent;
                        }
                    }
                });
        }
        this.chargingTypeActivationAlertModel = new AlertPanelModel(false, "", [""], "", "", true, "");
    }

    showPassengerLoadVehicleNotMappedAlert: boolean;
    passengerLoadVehicleNotMappedAlertModel: AlertPanelModel;

    fnShowPassengerLoadVehicleNotMappedAlertPanel() {
        if (this.expenseModel.passengerLoadVehicleActivationRequestStatus === ActivationRequestStatus.RequestSent) {
            this.passengerLoadVehicleNotMappedAlertModel = new AlertPanelModel(
                true,
                this.translate.instant("label_alert"),
                [],
                "",
                this.translate.instant("text_ok"),
                true,
                this.translate.instant("passenger_load_vehicle_request_sent_msg")
            );
        } else {
            this.passengerLoadVehicleNotMappedAlertModel = new AlertPanelModel(
                true,
                this.translate.instant("label_alert"),
                [],
                this.translate.instant("label_close"),
                this.translate.instant("send_request"),
                true,
                this.translate.instant("passenger_load_vehicle_not_mapped_alert")
            );
        }
        this.showPassengerLoadVehicleNotMappedAlert = true;
    }

    fnPassengerLoadVehicleNotMappedAlertReceiver(returnValue) {
        this.showPassengerLoadVehicleNotMappedAlert = false;
        if (returnValue && this.expenseModel.passengerLoadVehicleActivationRequestStatus !== ActivationRequestStatus.RequestSent) {
            let request = new ApiRequest<ActivationRequestModel>(
                "ActivationRequest",
                1.0,
                ""
            );
            let req = new ActivationRequestModel();
            req.id = 0;
            req.type = ActivationRequestType.PassengerLoadVehicleType;
            request.requestInfo = req;
            this.ukMileageRateSettingService
                .SoloSaveActivationRequest(request)
                .subscribe((res: IApiresponse<string>) => {
                    this.toastr.success(this.translate.instant("success"));
                    this.expenseModel.passengerLoadVehicleActivationRequestStatus = ActivationRequestStatus.RequestSent;
                });
        }
        this.passengerLoadVehicleNotMappedAlertModel = new AlertPanelModel(false, "", [""], "", "", true, "");
    }

}
